"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var El = _interopRequireWildcard(require("./DateFormatter.style"));
var _dateFormat = require("../../utils/dateFormat");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/* Style - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
/* Icons - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
var IconArrowRight = function IconArrowRight(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M15.494 12.6a.85.85 0 01-.253.51l-5.246 5.14a.89.89 0 01-.847.22.868.868 0 01-.619-.61.847.847 0 01.23-.828l4.624-4.532L8.76 7.968a.847.847 0 01-.23-.829.868.868 0 01.619-.61.89.89 0 01.847.221l5.246 5.14a.847.847 0 01.253.71z"
  }));
};
IconArrowRight.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
/* Utils - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
var DateFormatter = function DateFormatter(_ref) {
  var startDate = _ref.startDate,
    endDate = _ref.endDate,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    _ref$durationType = _ref.durationType,
    durationType = _ref$durationType === void 0 ? '' : _ref$durationType,
    _ref$rawStartDate = _ref.rawStartDate,
    rawStartDate = _ref$rawStartDate === void 0 ? '' : _ref$rawStartDate,
    _ref$rawEndDate = _ref.rawEndDate,
    rawEndDate = _ref$rawEndDate === void 0 ? '' : _ref$rawEndDate;
  var buildTemplate = function buildTemplate() {
    var options = {
      single: function Single() {
        return /*#__PURE__*/_react["default"].createElement(El.Date, {
          size: size
        }, (0, _dateFormat.removeYearDateFormat)(startDate));
      },
      multiple: function Multiple() {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(El.Date, {
          size: size
        }, (0, _dateFormat.dayMonthDateFormat)(startDate)), /*#__PURE__*/_react["default"].createElement(IconArrowRight, null), /*#__PURE__*/_react["default"].createElement(El.Date, {
          size: size
        }, (0, _dateFormat.dayMonthDateFormat)(endDate)));
      }
    };
    var checkDate = (0, _dateFormat.convertMilliseconds)(new Date(rawEndDate).getTime() - new Date(rawStartDate).getTime());
    return (checkDate === null || checkDate === void 0 ? void 0 : checkDate.day) > 0 ? options['multiple']() : options['single']() || null;
  };
  return /*#__PURE__*/_react["default"].createElement(El.DateContainer, {
    size: size
  }, durationType !== 'hidden' && buildTemplate());
};
var _default = DateFormatter;
exports["default"] = _default;
//# sourceMappingURL=DateFormatter.js.map